import { useTranslation } from 'react-i18next';
import { Typography, styled } from '@mui/material';
import Grid from '@mui/material/Grid';

import { Link } from 'lib/Link';

interface ErrorLayoutProps {
    description?: string;
    title: string;
    fallbackUrl?: string;
    fallbackTitle?: string;
    errorMessage?: string;
    onClick?: () => void;
}

const StyledFallback = styled('span')(({ theme }) => ({
    textDecoration: 'none',
    display: 'inline-block',
    cursor: 'pointer',
    color: theme.palette.primary.main
}));

export const ErrorLayout = (props: ErrorLayoutProps) => {
    const { description, fallbackTitle, fallbackUrl, errorMessage, title, onClick } = props;
    const { t } = useTranslation();

    return (
        <Grid
            container
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            sx={{ height: '100%', width: '100%' }}
        >
            <Grid>
                <Typography variant="h4" color="textPrimary">
                    {title}
                </Typography>
            </Grid>
            {description && description.length && (
                <Grid sx={{ marginTop: 1 }}>
                    <Typography variant="body1">{description}</Typography>
                </Grid>
            )}
            {errorMessage && errorMessage.length && (
                <Grid sx={{ marginTop: 1 }}>
                    <Typography variant="body1" color="error">
                        {errorMessage}
                    </Typography>
                </Grid>
            )}
            {fallbackUrl && (
                <Grid sx={{ marginTop: 1 }}>
                    <Typography variant="body1">
                        {t('GENERAL_RETURN_TO')}{' '}
                        <Link to={fallbackUrl} onClick={onClick}>
                            <StyledFallback>{fallbackTitle}</StyledFallback>
                        </Link>
                    </Typography>
                </Grid>
            )}
        </Grid>
    );
};
